import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      // Light is the default surface on desktop web. Native always forces
      // light in ThemeProvider regardless of this value.
      theme: "light",
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set((s) => ({ theme: s.theme === "light" ? "dark" : "light" })),
    }),
    {
      name: "campushubai-theme",
      // v1: light is the product default on desktop. Prior builds defaulted
      // to dark (and even migrated stored light→dark), so nearly every
      // persisted value is dark-by-default rather than a deliberate choice.
      // This one-time migration resets everyone to light; users who prefer
      // dark can toggle back and that choice persists normally.
      version: 1,
      migrate: (persisted) => ({ ...(persisted as ThemeState), theme: "light" }),
    }
  )
);
